import React from 'react';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';

import TToastIcon from './@types/TToastIcon';

const ToastIcon = ({ icon }: TToastIcon) => (
  <Box as="div" parent="Toast" name="icon">
    <Icon name={icon} size="m" />
  </Box>
);

export default ToastIcon;
